import React from 'react';
import { ClockIcon, FolderSearchIcon, MoonIcon, PuzzleIcon, SparklesIcon } from 'lucide-react';
import { recognizeItems, volumeColors } from '../data/content';
import { Highlight } from './Highlight';
const icons = [ClockIcon, SparklesIcon, PuzzleIcon, FolderSearchIcon, MoonIcon];
export function Recognize() {
  return <section className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-228" data-mp="2r6dacclulck0">
      <div className="mx-auto max-w-5xl" data-id="element-229" data-mp="2m824ecyobm72">
        <h2 className="mx-auto max-w-3xl text-center font-display text-[1.75rem] font-black leading-tight tracking-tight text-ink sm:text-5xl" data-id="element-230" data-mp="2m93eof7v84nq">
          Do You <Highlight data-id="element-231" data-mp="2d7lyyxyde4zk">Recognize Yourself</Highlight> in These Situations?
        </h2>

        <ul className="mt-12 grid gap-4 md:grid-cols-2" data-id="element-232" data-mp="2d9gnsncrih8x">
          {recognizeItems.map((item, index) => {
          const Icon = icons[index % icons.length];
          const color = volumeColors[index % volumeColors.length];
          const isLast = index === recognizeItems.length - 1;
          return <li key={item.title} className={`flex gap-4 rounded-2xl bg-paper p-5 sm:p-6 ${isLast ? 'md:col-span-2' : ''}`} data-id="element-233" data-mp="6fcw0byqf560" data-mpi={index}>
                <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl ${color.bg} ${color.fg}`} data-id="element-234" data-mp="3nmfarb3tf0wj">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-235" data-mp="39nxsvu0lcimj" />
                </span>
                <div data-id="element-236" data-mp="3el7gr58c0m89">
                  <p className="font-display text-base font-bold leading-snug text-ink" data-id="element-237" data-mp="3emsbovyk676n">
                    {item.title}
                  </p>
                  <p className="mt-1.5 text-sm leading-relaxed text-ink-soft" data-id="element-238" data-mp="b5af5ko8kmlj">
                    {item.text}
                  </p>
                </div>
              </li>;
        })}
        </ul>

        <p className="mt-12 text-center font-display text-xl font-black text-royal sm:text-2xl" data-id="element-239" data-mp="3sjxmf997vu88">
          Your next teaching week doesn’t have to start the same way.
        </p>
      </div>
    </section>;
}